












import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import dayjs from 'dayjs';
import 'dayjs/locale/es';

import ChartComponent from '@/modules/shared/components/chart.component.vue';


interface ChartDataset {
    label: string;
    data: number[];
    backgroundColor: string;
    borderColor: string;
    borderWidth: number;
}

@Component({
    components: {
        ChartComponent,
    },
    computed: {
        ...mapGetters({
            generalStats: 'getGeneralMonthlyStatsList',
            sellerStats: 'getSellerMonthlyStatsList',
            fullName: 'getProfileFullName',
        }),
    },
})
export default class GeneralComparision extends Vue {
    private literals = {
        title: 'Comparativo de ventas',
    };
    private generalStats!: any[];
    private sellerStats!: any[];
    private fullName!: string;
    private type!: string;
    private options!: any;
    private months: number = 6;


    private created() {
        this.initializeChart();
        this.fetchMontlyStats();
    }


    get chartData() {
        return {
            labels: this.getMonthNames,
            datasets: this.dataSets,
        };
    }

    get dataSets() {
        return [
            this.getSellerDataset,
            this.getGeneralDataset,
        ];
    }

    get getMonthNames() {
        const monthList: string[] = [];
        const firstDate = dayjs().subtract((this.months - 1), 'month');
        for (let index = 0; index < this.months; index++) {
            const currentDate = firstDate.add(index, 'month');
            monthList.push(`${(currentDate.locale('es') as any).format('MMM')}.`);
        }
        return monthList;
    }

    get getSellerDataset(): ChartDataset {
        let data = this.emptyData;
        if (this.sellerStats.length > 0) {
            data = this.sellerStats;
        }
        return {
            label: this.fullName,
            data,
            backgroundColor: 'rgba(231, 161, 23, 0.2)',
            borderColor: 'rgba(231, 161, 23, 1)',
            borderWidth: 1,
        };
    }

    get getGeneralDataset(): ChartDataset {
        let data = this.emptyData;
        if (this.generalStats.length > 0) {
            data = this.generalStats;
        }
        return {
            label: 'Media general',
            data,
            backgroundColor: 'rgba(82, 87, 93, 0.2)',
            borderColor: 'rgba(82, 87, 93, 1)',
            borderWidth: 1,
        };
    }

    get emptyData(): number[] {
        const data: number[] = [];
        for (let index = 0; index < this.months; index++) {
            data.push(0);
        }
        return data;
    }


    private initializeChart() {
        this.type = 'line';
        this.options = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                    },
                }],
            },
            legend: {
                position: 'bottom',
                align: 'end',
                rtl: true,
                labels: {
                    fontSize: 16,
                    fontColor: '#232931',
                    fontFamily: 'Poppins',
                    padding: 35,
                    usePointStyle: true,
                },
            },
        };
    }

    private fetchMontlyStats() {
        this.$store.dispatch('fetchMonthlyStatsList', { months: this.months });
    }
}
